import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { DateTime, Settings } from 'luxon';

import { defaultTheme } from '../../../../assets/css/defaultTheme';
import history from '../../../../routes/history';
import { ITeamMember } from '../../../myTeam/reducers';
import { IService } from '../../../serviceOrdering/reducers';
import { AgendaRangeMinute } from '../../types';
import AgendaTaskComponent from '../AgendaEventComponent';

Settings.defaultLocale = 'fr';

export interface AgendaTaskMakerProps {
  cellDateTime: DateTime;
  range: AgendaRangeMinute;
  services: IService[];
  team: ITeamMember[];
}

const AgendaTaskMaker = ({ cellDateTime, range, services, team }: AgendaTaskMakerProps) => {
  const { length } = services;
  // Calculate width based on services length
  const width = length > 1 ? Math.floor(100 / length) : 100;

  const generateEmptyEvent = () => {
    return (
      <>
        <OverlayTrigger
          trigger="focus"
          placement="bottom"
          overlay={
            <Tooltip className="popover" placement="bottom">
              <p className="title-event m-0 text-wrap text-center">
                Aucun rendez-vous prévu le {cellDateTime.toFormat('dd/MM/yyyy à HH:mm')}
              </p>
              <Button
                variant="primary"
                className="btn-sm"
                onClick={() => history.push('/new-order', { date: cellDateTime })}
              >
                Prendre rendez-vous ?
              </Button>
            </Tooltip>
          }
        >
          <Button variant="none" style={{ width: 'inherit', height: '100%' }}></Button>
        </OverlayTrigger>
      </>
    );
  };

  const generateEvent = (service: IService) => {
    const color =
      team.find((member: ITeamMember) => member.id === service?.teamMember?.id)?.color ??
      defaultTheme.palette.primary.main;

    return <AgendaTaskComponent color={color} range={range} service={service} />;
  };

  return (
    <>
      {length === 0 ? (
        generateEmptyEvent()
      ) : (
        <div className="d-flex">
          {services.map((value, index) => {
            return (
              <div key={index} style={{ width: width + '%' }}>
                {generateEvent(value)}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default AgendaTaskMaker;
